import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const InstallPWA = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstall(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      console.log('✓ PWA instalado com sucesso!');
    }
    
    setDeferredPrompt(null);
    setShowInstall(false);
  };

  if (!showInstall) return null;

  return (
    <div className="fixed bottom-20 right-4 z-50 animate-slide-up">
      <div className="bg-white rounded-xl shadow-2xl border border-red-200 p-4 max-w-sm">
        <button
          onClick={() => setShowInstall(false)}
          className="absolute top-2 right-2 p-1 hover:bg-slate-100 rounded"
        >
          <X className="w-4 h-4 text-slate-400" />
        </button>
        
        <div className="flex items-start space-x-3 pr-6">
          <div className="w-12 h-12 bg-gradient-to-br from-red-600 to-orange-600 rounded-lg flex items-center justify-center flex-shrink-0">
            <Download className="w-6 h-6 text-white" />
          </div>
          <div className="flex-1">
            <h3 className="font-bold text-slate-900 mb-1">Instalar App</h3>
            <p className="text-sm text-slate-600 mb-3">
              Instale o Financeiro BoraCar e acesse como aplicativo!
            </p>
            <Button
              onClick={handleInstall}
              className="w-full bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700"
            >
              <Download className="w-4 h-4 mr-2" />
              Instalar Agora
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstallPWA;
